let unauthorizedHandler = null;
let isHandlingUnauthorized = false;

export const registerUnauthorizedHandler = (handler) => {
    unauthorizedHandler = handler;
};

export const handleUnauthorized = () => {
    if (isHandlingUnauthorized) return;

    isHandlingUnauthorized = true;

    sessionStorage.removeItem("userdetails");

    if (unauthorizedHandler) {
        unauthorizedHandler();
    }
};

export const resetUnauthorizedState = () => {
    isHandlingUnauthorized = false;
};